import { NAMESPACE as UI_KIT_NAMESPACE, PdfViewer } from '@ui-kit'
import React, { useEffect, useState } from 'react'
import { FilePreviewProps } from '../../utils/types'
import { FILE_TYPE_TOASTER } from '@ui-kit'
import { EXTENSIONS, NAMESPACES } from '../../utils/constants'

const FilePreview: React.FC<FilePreviewProps> = ({
  url,
  fileType,
  setTotalPages,
  docxPreviewUrl,
}) => {
  const [textContent, setTextContent] = useState<string>('')
  const [isLoadingText, setIsLoadingText] = useState<boolean>(false)

  useEffect(() => {
    let isCancelled = false

    const fetchTextContent = async () => {
      if (fileType === EXTENSIONS.TXT && url) {
        setIsLoadingText(true)
        setTextContent('')
        try {
          const response = await fetch(url)
          const text = await response.text()
          if (!isCancelled) {
            setTextContent(text)
          }
        } catch (error) {
          console.error('Error fetching text file:', error)
          if (!isCancelled) {
            setTextContent('Error loading text file')
          }
        } finally {
          if (!isCancelled) {
            setIsLoadingText(false)
          }
        }
      } else {
        setTextContent('')
        setIsLoadingText(false)
      }
    }

    fetchTextContent()

    return () => {
      isCancelled = true
    }
  }, [url, fileType])

  if (!url) {
    return (
      <div className="flex items-center justify-center w-full h-full bg-gray-50">
        <p className="text-gray-500">
          {UI_KIT_NAMESPACE.SCAN_IN_PROGRESS_DOCUMENT_TOOLTIP}
        </p>
      </div>
    )
  }

  if (fileType === EXTENSIONS.PDF) {
    return (
      <PdfViewer
        pdfUrl={url}
        height=""
        setTotalPages={setTotalPages}
        defaultZoomScale={1}
      />
    )
  }

  if (fileType === EXTENSIONS.IMAGE) {
    return (
      <div className="flex items-center justify-center w-full h-full bg-gray-50 overflow-auto">
        <img
          src={url}
          alt={NAMESPACES.PREVIEW}
          className="max-w-full max-h-full object-contain"
        />
      </div>
    )
  }

  if (fileType === EXTENSIONS.DOCX || fileType === EXTENSIONS.DOC) {
    const previewUrl = docxPreviewUrl ?? url
    return (
      <PdfViewer
        pdfUrl={previewUrl}
        height=""
        setTotalPages={setTotalPages}
        defaultZoomScale={1}
      />
    )
  }

  if (fileType === EXTENSIONS.TXT) {
    return (
      <div className="flex w-full h-full bg-white overflow-auto">
        {isLoadingText ? (
          <p className="text-gray-500 p-4">{NAMESPACES.LOADING_PLACEHOLDER}</p>
        ) : (
          <pre
            className="font-mono text-sm text-gray-900 p-4 m-0 w-full"
            style={{ whiteSpace: 'pre' }}
          >
            {textContent}
          </pre>
        )}
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center w-full h-full bg-gray-50">
      <p className="text-gray-500">
        {FILE_TYPE_TOASTER.FILE_TYPE_NOT_SUPPORTED}
      </p>
    </div>
  )
}

export default FilePreview
